export default __webpack_public_path__ + "static/media/submit.17a53a5a.PNG";